<template>
  <div class="pageStyle">
    <div
      class="topBg"
      :style="
        depConfig.topBlockBg
          ? {
              backgroundImage: 'url(' + depConfig.topBlockBg + ')',
            }
          : ''
      "
    >
      <!-- 搜索栏行和页面标题 -->
      <headerDiv
        ref="headerDiv"
        v-if="depConfig.depName != 'hpmra' && depConfig.depName != 'whicpa'"
        :depConfig="depConfig"
      ></headerDiv>
      <!-- 绩效会定制版：搜索栏行和页面标题  -->
      <headerDivHpmra
        ref="headerDivHpmra"
        v-if="depConfig.depName == 'hpmra'"
        :depConfig="depConfig"
      ></headerDivHpmra>

      <!-- 企业服务 商协会、会计师不可见 -->
      <enterpriseServices
        ref="enterpriseServices"
        v-if="
          enterpriseServicesShow &&
          depConfig.depName != 'hpmra' &&
          depConfig.depName != 'whicpa'
        "
      ></enterpriseServices>
      <!-- 绩效会定制版：企业服务 -->
      <enterpriseServicesHpmra
        ref="enterpriseServicesHpmra"
        v-if="enterpriseServicesShow && depConfig.depName == 'hpmra'"
        :depConfig="depConfig"
      ></enterpriseServicesHpmra>

      <!-- 长条形轮播图 -->
      <swipePoster v-if="isShow['bannerFlag']" ref="swipePoster"></swipePoster>

      <!-- 小功能合集 商协会不可见 -->
      <funSummary ref="funSummary" v-if="isShow['toolsetFlag']"></funSummary>

      <!-- 海报模块 -->
      <!-- <poster ref="poster"></poster> -->

      <!-- 产品列表模块 绩效会没有 -->
      <productList
        v-if="
          depConfig.depName != 'hpmra' &&
          depConfig.depName != 'whicpa' &&
          depConfig.depName != 'xrr'
        "
        ref="productList"
        :depConfig="depConfig"
      ></productList>

      <!-- 单独配置的产品列表模块 退役军人协会定制 xrr -->
      <productListForXrr
        v-if="depConfig.depName == 'xrr'"
        ref="productList"
        :depConfig="depConfig"
      ></productListForXrr>

      <!-- 浮窗广告位置 -->
      <!-- <div class="floating" ref="floating">
        <img
          :src="depConfig.flowBtnSrc"
          v-show="depConfig.flowBtnSrc"
          @click="toUrl(depConfig.flowBtnImgUrl)"
          alt=""
        />
      </div> -->
    </div>
    <!-- 加载中遮罩层 跟Toast区别出来 -->
    <van-overlay class="overlayShow" :show="overlayShow" z-index="999">
      <div class="wrapper" @click.stop>
        <div class="loadingBox">
          <van-loading size="24px" color="white" vertical>加载中</van-loading>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import poster from "./module/poster";
import productList from "./module/productList";
import productListForXrr from "./module/productListForXrr";
import funSummary from "./module/funSummary";
import headerDiv from "./module/headerDiv";
import headerDivHpmra from "./module/headerDiv-hpmra";
import enterpriseServicesHpmra from "./module/enterpriseServices-hpmra";
import swipePoster from "./module/swipePoster";
import enterpriseServices from "./module/enterpriseServices";
import { genCompanyRepoPost } from "@/api/product.js";
import { getToken } from "@/utils/auth.js";
import { updateWxInfo } from "@/api/wx.js";
import { getWxUserInfo } from "@/utils/index";
import { getDepNameByDomain } from "@/utils/index";
import { getChannelToken } from "@/api/login.js";
import { setToken } from "@/utils/auth.js";
import { xcDepConfig } from "@/api/depConfig.js";
import { getWx } from "@/utils/wxJsSdk.js";
import { getCurrentChannelInfo } from "@/api/login.js";
import Vue from "vue";
import { Icon, Tab, Tabs, Toast, Overlay, Loading } from "vant";
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Overlay);
Vue.use(Icon);
Vue.use(Loading);
export default {
  components: {
    poster,
    productList,
    funSummary,
    headerDiv,
    headerDivHpmra,
    swipePoster,
    enterpriseServices,
    enterpriseServicesHpmra,
    productListForXrr,
  },
  watch: {},
  data() {
    return {
      depName: "",
      depConfig: {},
      isShow: {
        bannerFlag: false,
        toolsetFlag: false,
      },
      // 税局状态
      // 页面滑动时的数据
      startY: "",
      moveY: "",
      enterpriseServicesShow: false,
      // 加载中遮罩层
      overlayShow: false,
    };
  },
  mounted() {
    // 获取分享内容模板
    this.getShareTxt();
    // 判断是否携带回调地址参数
    this.isRedirectUrl();
  },
  created() {},

  methods: {
    // 判断是否携带回调地址参数
    isRedirectUrl() {
      let redirectUrl = this.$route.query.redirectUrl;
      // 有带回调地址参数 判断是否登录
      // 没带回调地址参数 不操作
      if (redirectUrl) {
        // 判断是否登录
        if (getToken()) {
          // 打开遮罩层
          this.overlayShow = true;
          // 获取渠道用户信息
          getCurrentChannelInfo()
            .then((res) => {
              // 使用replace方法替换当前历史记录，确保返回时不携带redirectUrl参数
              this.$router.replace({
                path: this.$route.path,
                query: {},
              });
              // 判断回调地址是否为企业报告地址
              // https://xccompanyrepo.xchengtech.cn
              if (
                redirectUrl.indexOf("https://xccompanyrepo.xchengtech.cn") > -1
              ) {
                // 获取企业报告
                genCompanyRepoPost()
                  .then((ress) => {
                    window.location.href = ress.link;
                  })
                  .catch((errr) => {
                    console.log("errr", errr);
                    this.overlayShow = false;
                  });
              }
              // 判断回调地址是否为独立页面项目的地址 是的话则加上渠道id
              else if (
                redirectUrl.indexOf("https://independentpage.xchengtech.cn") >
                -1
              ) {
                setTimeout(() => {
                  this.toUrl(redirectUrl + "?channelId=" + res.id);
                }, 0);
              }
              // 其他回调地址 直接跳转
              else {
                // 延迟执行跳转，确保历史记录已更新
                setTimeout(() => {
                  this.toUrl(redirectUrl);
                }, 0);
              }
            })
            .catch((err) => {
              console.log("err", err);
              this.overlayShow = false;
            });
        }
        // 未登录,前去登录
        else {
          this.$router.push({
            path: "/login",
            query: {
              redirectUrl: redirectUrl,
            },
          });
        }
      }
    },
    getShareTxt() {
      this.depName = getDepNameByDomain();
      xcDepConfig(this.depName).then((res) => {
        console.log("res", res);
        this.depConfig = res;
        // 保存平台类型到 store
        this.$store.commit('SetPlatformType', res.platformType || 'portal');
        // 是否有定制的页面标题
        if (this.depConfig.indexPageTitle) {
          document.title = this.depConfig.indexPageTitle;
        }
        // 判断是否打开轮播图
        console.log('[DEBUG] bannerFlag before:', this.isShow.bannerFlag, 'depConfig.bannerFlag:', this.depConfig.bannerFlag);
        this.isShow.bannerFlag = this.depConfig.bannerFlag;
        console.log('[DEBUG] bannerFlag after:', this.isShow.bannerFlag);

        // 判断是否打开小功能合集
        console.log('[DEBUG] toolsetFlag before:', this.isShow.toolsetFlag, 'depConfig.toolsetFlag:', this.depConfig.toolsetFlag);
        this.isShow.toolsetFlag = this.depConfig.toolsetFlag;

        // 判断是否商协会模式
        let desc = "";
        if (
          this.depConfig.bizType == "csqfpt" ||
          this.depConfig.bizType == "ssh"
        ) {
          // 配置微信分享文字
          desc = "欢迎来到湖南社会组织金融赋能平台";
          this.enterpriseServicesShow = false;
        }
        // 其他租户
        else {
          desc = "欢迎来到" + res.depTitle;
          this.enterpriseServicesShow = true;
        }

        let icon = this.depConfig.channelLogoSrc
          ? this.depConfig.channelLogoSrc
          : "https://static.xchengtech.cn/4a6254f9d27042ddabb8c7d8c766b9bc.png";
        // 退役军人协会定制 xrr
        if (this.depConfig.depName == 'xrr') {
          icon = "https://static.xchengtech.cn/58d38e065164400c8105e2fa6487a3df.png"
          desc = "欢迎来到湖南省退役军人金融服务平台"
        }
        getWx().then((res) => {
          window.wx.updateAppMessageShareData({
            title: "企业数智服务中心", // 分享标题
            desc: desc, // 分享描述
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: icon, // 分享图标
            success: function (res) {
              console.log("res", res);
              //afterShare();
            },
          });
        });
        // 判断是否是商协会模式
        if (
          this.depConfig.bizType != "ssh" &&
          this.depConfig.bizType != "csqfpt"
        ) {
          // 不属于商协会 才更新用户信息
          this.updateUserInfo();
        }
      });
    },
    // 更新用户信息
    updateUserInfo() {
      let userInfo = getWxUserInfo();
      // 如果有token的话，代表已登录，更新渠道微信信息
      if (getToken()) {
        // 判断是否有userinfo
        if (userInfo) {
          let body = {
            openId: userInfo.openid,
            headImgUrl: userInfo.headimgurl,
            nickName: userInfo.nickname,
          };
          updateWxInfo(body)
            .then((res) => {
              console.log("res", res);
            })
            .catch((err) => {
              console.log("err", err);
            });
        }
      }
      // 没有token的话,通过openid获取该渠道的token
      else {
        if (userInfo) {
          let body = {
            depName: getDepNameByDomain(),
            openId: userInfo.openid,
          };
          getChannelToken(body).then((res) => {
            if (res.token) {
              setToken(res.token);
            }
          });
        }
      }
    },
    // 屏幕滑动事件
    touchstart(e) {
      this.startY = e.touches[0].clientY;
    },
    touchmove(e) {
      this.moveY = e.touches[0].clientY;
      //  this.startY - this.moveY <= 0 ? console.log('你在往上滑') : console.log('你在往下滑')
      if (this.startY - this.moveY <= 0) {
        // 从上往下拉 显示
        this.$refs["floating"].style.right = "2vw";
      } else {
        // 从下往上拉 隐藏
        this.$refs["floating"].style.right = "-10vw";
      }
    },
    toPage(name) {
      switch (name) {
        default:
          this.$router.push({ path: "/" + name });
          break;
      }
    },
    toUrl(url) {
      if (url) window.location.href = url;
    },
  },
};
</script>
<style scoped>
.pageStyle {
  font-size: 3.6vw;

  background-color: #f7f7f9;
}
.topBg {
  /* background: linear-gradient(to bottom, #2841c1 5%, #f7f7f9 8%); */
  background-image: url("https://static.xchengtech.cn/bab98024e59344128fa66b87e52c0f4d.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: top;
  min-height: 100vh;
}

/* 税局状态小图标 */
.floating {
  position: fixed;
  top: 73%;
  right: 2vw;
  width: 14vw;
  /* height: 10vw; */
  z-index: 999;
  transition: all 0.25s ease-in-out;
}

.floating img {
  display: block;
  /* border-radius: 35px; */
  width: 100%;
}
.overlayShow .loadingBox {
  padding: 36px 41px;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
  white-space: pre-wrap;
  text-align: center;
  word-break: break-all;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 8px;
}
.overlayShow .wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/view/productList/index.vue